import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/ec.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/ihc.png";
import chatify from "../../Assets/Projects/spot.png";
import suicide from "../../Assets/Projects/pong.png";
import bitsOfCode from "../../Assets/Projects/3d.png";
import mf from "../../Assets/Projects/mf.png";
import pz from "../../Assets/Projects/pz.png";
import login from "../../Assets/Projects/login.png";
import eui from "../../Assets/Projects/Eui.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="FlavorFlenzy"
              description="FlavorFrenzy is a recipe website with a wide variety of cuisines and dietary options. Discover and share delicious recipes with easy-to-follow instructions and vibrant images. Join the frenzy and let your taste buds be tantalized!"
             
              
              ghLink="https://github.com/PraveenNanda124/FlavorFlenzy.git"
              demoLink="https://sweet-sundae-f41128.netlify.app"
            />
          </Col>
         
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={login}
              isBlog={false}
              title="Rosa 2"
              description="Our food delivery website project lets customers order from local restaurants and have meals delivered to their doorstep. With an intuitive interface, customizable orders, and real-time tracking, it offers a hassle-free solution for those who crave restaurant-quality meals at home."
              ghLink="https://github.com/PraveenNanda124/Rosa2.git"
              demoLink="https://demos.pixelgrade.com/rosa2-lite/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eui}
              isBlog={false}
              title="MoneyMinder"
              description=" MoneyMinder is a personal finance app with budgeting and expense tracking features. Set financial goals, monitor your spending, and make informed decisions about your money. Stay on top of your bills, track investments, and plan for the future. MoneyMinder makes managing your finances easy and stress-free."
              ghLink="https://github.com/PraveenNanda124/MoneyMinder.git"
              demoLink="https://expenseapprtk.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="FarmHub"
              description="FarmHub is an online platform connecting farmers and consumers. Farmers can list their products and manage orders, while consumers can browse and purchase locally grown and artisanal products. FarmHub supports local agriculture and creates a more sustainable food system."
              ghLink="https://github.com/PraveenNanda124/FarmHub.git"
              demoLink="https://remarkable-jalebi-cad8bf.netlify.app/"
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Flappy Bird"
              description="Flappy Bird is a mobile game where players control a bird, trying to fly between pipes without hitting them. The simple gameplay involves tapping the screen to make the bird flap its wings and move upwards. Flappy Bird became popular for its addictive gameplay and minimalist graphics."
              ghLink="https://github.com/PraveenNanda124/FlappyBird.git"
              demoLink="https://flappy-bird-rust.vercel.app/"     
            />
             
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="WeatherCast"
              description="WeatherCast is a React-based weather app that provides accurate and up-to-date weather forecasts for your location and any other location you want to check. Stay prepared and informed with WeatherCast."
              ghLink="https://github.com/PraveenNanda124/WeatherCast.git"
              demoLink="https://weather.iondrimbafilho.me/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="MyCharity"
              description="MyCharity is a charity website that connects donors with a variety of nonprofit organizations, allowing them to make easy and secure online donations. The website offers a user-friendly platform for users to search for and support causes they care about, with options to donate to specific projects or ongoing programs."
              ghLink="https://github.com/PraveenNanda124/My.Charity.git"
              demoLink="http://website-templates.github.io/charity_responsive-template/"              
            />
          </Col>

          

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Currents24"
              description="Currents24 is a DNA cloning news app that provides short and concise updates on the latest advancements in the field. The app is perfect for anyone who wants to stay informed on the go, with quick and easy-to-read news summaries. Stay up-to-date with the latest developments in DNA cloning with Clone Update.



              "
              ghLink="https://github.com/PraveenNanda124/Currents24.git"
              demoLink="https://profound-axolotl-8f7b93.netlify.app/" 
            />
          </Col>

          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pz}
              isBlog={false}
              title="QuickBuy"
              description="QuickBuy is an affordable and stylish online clothing store for men and women, offering a personalized shopping experience with free shipping and easy returns."
              ghLink="https://github.com/PraveenNanda124/QuickBuy.git"
              demoLink="https://dashing-banoffee-37510e.netlify.app/"
            />
          </Col>
          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mf}
              isBlog={false}
              title="Moving-Fan"
              description="Created a simple graphical image of fan with on and off buttons and spped range buttons from 1-5.The fan spped changes according to the range."
              ghLink="https://github.com/PraveenNanda124/Moving-Fan.git"
              demoLink="https://moving-fan.netlify.app/"
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
